import React from 'react'
import '../App.css'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
//import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
//import CalendarIcon from '@material-ui/icons/CalendarToday';
//import Button from '@material-ui/core/Button';

//import CloseIcon from '@material-ui/icons/Close';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ReactTooltip from "react-tooltip"
import * as d3 from 'd3';
//import { FormHelperText } from '@material-ui/core';

import YearCalendar from './yearCalendar'

const styles = theme => ({
  progress: {
    margin: theme.spacing() * 2,
  },
  container: {
    textAlign: 'center',
    //borderLeft: '3px solid #165469',
    fontFamily: 'Nunito Sans SemiBold',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '110px',
    maxHeight: '110px',
    /*
    [theme.breakpoints.up('tablet')]: {
      minHeight: '140px',
      maxHeight: '140px',
    }, [theme.breakpoints.up('md')]: {
      minHeight: '125px',
      maxHeight: '125px',
    },
    */
  },
  heading: {
    color: '#069999!important',
    fontSize: '14pt',
    textAlign: 'center',
    width: '100%',
  },
  selectorContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingLeft: '10px',
    height: '60px',
  },
  dateContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    //alignItems: 'center',

    minHeight: '30px',
    height: '30px',
    maxHeight: '30px',
  },
  activeDateContainer: {
    borderRadius: '5px!important',

    minHeight: '60px',
    height: '60px',
    maxHeight: '60px',
  },
  dateSelector: {
    //padding: theme.spacing() * 2,
    margin: '0px',
    textAlign: 'center',
    //fontSize: '17px',
    borderRadius: '0!important',
    lineHeight: '30px',

    minHeight: '30px',
    height: '30px',
    maxHeight: '30px',
  },
  activeDateSelector: {
    borderRadius: '5px!important',

    minHeight: '60px',
    height: '60px',
    maxHeight: '60px',
  },
  yearSelector: {
    lineHeight: '60px!important',
  },
  borderLeftRounded: {
    borderTopLeftRadius: '10px!important',
    borderBottomLeftRadius: '10px!important',
    borderTopRightRadius: '0!important',
    borderBottomRightRadius: '0!important',
  },
  borderRightRounded: {

    borderTopRightRadius: '10px!important',
    borderBottomRightRadius: '10px!important'
  },
  questionContainer: {
    paddingTop: '1px',
    paddingBottom: '1px',
    lineHeight: '30px!important',
  },
  hoverable: {
    textDecoration: 'none',
    '&:hover': {
      //color: 'white!important',
      cursor: 'pointer',
      backgroundColor: '#dbdbdb',
    },
  },

  //spreader: {
  //  display: 'flex',
  //  justifyContent: 'center',
  //  marginTop: '0',
  //  marginBottom: '0',
  //  paddingTop: '6px',
  //  paddingBottom: '6px',
  //},
  active: {
    fontWeight: '700!important',
  },
  activeLink: {
    textDecoration: 'underline',
    fontFamily: 'Nunito Sans Black!important',
    //fontWeight: '700!important',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#dbdbdb',
    },
  },
  toolTip: {
    textAlign: 'left',
    color: '#165469!important',
    backgroundColor: '#aaaaaa',
    fontFamily: 'Nunito Sans Regular!important',
  },
  year: {
    color: '#165469!important',
    fontFamily: 'Nunito Sans Regular!important',
  },
});

function DateSelector(props) {
  const { classes } = props;
  //let switchToHistorical

  let warningOneYearAgo
  let warningAvailableTomorrow

  let previousYear = parseInt(props.selectedYear) - 1;
  let nextYear = parseInt(props.selectedYear) + 1;
  let tooltipYearBeforeText
  let availableFromJanuary

  let chooseA
  let day
  let or
  let year

  let locale
  switch (props.lang) {
    case "de":
      //switchToHistorical="Jaar data"
      warningOneYearAgo = "Tagesdaten sind nur für die letzten 30 Tage verfügbar"
      warningAvailableTomorrow = "Ab morgen verfügbar"
      tooltipYearBeforeText = "Jahresdaten sind erst ab 2015 verfügbar"
      availableFromJanuary = "ab Februar " + nextYear + " erhältlich "

      chooseA = 'Wahlen sie'
      day = 'den Tag'
      or = 'oder'
      year = 'das Jahr'

      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "shortMonths": ["Jan", "", "Mar", "", "Mai", "", "Jul", "", "Sep", "", "Nov", ""]
      })
      break;
    case "en":
      //switchToHistorical="Year View"
      warningOneYearAgo = "daily archive goes back one month in time"
      warningAvailableTomorrow = "available from tomorrow"
      tooltipYearBeforeText = "archive goes back to 2015"
      availableFromJanuary = "available from February " + nextYear

      chooseA = 'Choose'
      day = 'the day'
      or = 'or'
      year = 'the year'

      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "shortDays": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "shortMonths": ["Jan", "", "Mar", "", "May", "", "Jul", "", "Sep", "", "Nov", ""]
      })
      break;
    case "fr":
    default:
      //switchToHistorical="Vue des années"
      warningOneYearAgo = "les archives quotidiens remontent un mois dans le temps"
      warningAvailableTomorrow = "disponible à partir de demain"
      tooltipYearBeforeText = "les archives remontent jusqu'à 2015"
      availableFromJanuary = "disponible à partir de février " + nextYear

      chooseA = 'Choisissez le'
      day = 'jour'
      or = 'ou'
      year = 'l\'année'

      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        "shortDays": ["Di", "Lu", "Ma", "Mi", "Je", "Ve", "Sa"],
        "months": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
        "shortMonths": ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"]
      })
  }

  const boolHigherHeader = (props.windowWidth >= 1280 &&
    (
      (props.lang === "de" && props.windowWidth < 1660) ||
      (props.lang === "en" && props.windowWidth < 1536) ||
      props.windowWidth < 1440
    )
  )

  const currentYear = parseInt(d3.timeFormat('%Y')(new Date()))
  let nextYearNavigationDisabled = (nextYear > currentYear) || (currentYear - 1 === props.selectedYear && props.currentYearNavigationDisabled)
  
  if (!props.showCalendar) {
    if (props.currentMode === 'realtime') {
      let previousDay = d3.timeDay.offset(props.selectedDate, -1)
      let nextDay = d3.timeDay.offset(props.selectedDate, +1)

      let oneYearAgoTomorrow = new Date(new Date().getTime() + 86400000)
      oneYearAgoTomorrow.setYear(oneYearAgoTomorrow.getYear() - 1)

      let previousDayNavigationDisabled = (nextDay.toDateString() === oneYearAgoTomorrow.toDateString());
      let nextDayNavigationDisabled = (previousDay.toDateString() === (new Date()).toDateString());

      const tooltipDayBefore =
        <ReactTooltip id='day_before_tooltip' type='light' place='left' className={classes.toolTip}>
          <p>{warningOneYearAgo}</p>
        </ReactTooltip>

      const tooltipDayAfter =
        <ReactTooltip id='day_after_tooltip' type='light' place='right' className={classes.toolTip}>
          <p>{warningAvailableTomorrow}</p>
        </ReactTooltip>

      return (
        <Grid item container xs={12}
          className={classes.container + ' darkbluegreen'}
          style={{
            minHeight: (boolHigherHeader ? '130px' : '110px'),
            maxHeight: (boolHigherHeader ? '130px' : '110px'),
          }}
        >
          <Grid item className={classes.heading}>
            {chooseA} <span
              className={classes.activeLink + " mediumgreen"}
              onClick={() => props.displayCalendar(true, 'realtime')}
            >{day}</span> {or} <span
              className={classes.activeLink + " mediumgreen"}
              onClick={() => props.displayCalendar(true, 'historical')}
            >{year}</span>
          </Grid>
          <Grid item container xs={12} className={classes.selectorContainer}>
            <Grid item container xs={4} className={classes.dateContainer}>
              {
                previousDayNavigationDisabled ?
                  <Paper
                    className={classes.questionContainer + ' secondaryHeaderBackground bgmediumgrey mediumgreen ' + classes.hoverable + ' ' + classes.borderLeftRounded}
                  >
                    <IconButton className={classes.toolTipIconButton} data-for='day_before_tooltip' data-tip='day_before_tooltip'>
                      <HelpOutlineIcon />
                      {tooltipDayBefore}
                    </IconButton>
                  </Paper>
                  :
                  <Paper
                    className={classes.dateSelector + ' secondaryHeaderBackground bgmediumgrey mediumgreen ' + classes.hoverable + ' ' + classes.borderLeftRounded}
                    onClick={() => props.changeCurrentDaySelected(d3.timeFormat('%Y%m%d')(previousDay))}
                  >
                    {
                      /*
                      <div className="bold" style={{ fontSize: '1.1em', }}>
                        {d3.timeFormat('%A')(previousDay)}
                      </div>
                      */
                    }

                    <div>
                      {d3.timeFormat('%e %B')(previousDay)}
                    </div>
                  </Paper>
              }
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer + ' ' + classes.activeDateContainer}>
              <Paper
                className={classes.dateSelector + ' ' + classes.activeDateSelector + ' activeHeaderText bggreenblue'}
              >
                <div className="bold" style={{ fontSize: '1.1em', }}>
                  {d3.timeFormat('%A')(props.selectedDate)}
                </div>
                <div>
                  {d3.timeFormat('%e %B')(props.selectedDate)}
                </div>
                {
                  /*
                  <IconButton className=  {classes.calendarIconButton}  onClick={()=>props.showCalendar(true)}>
                    <CalendarIcon />
                  </IconButton>
                  */
                }

              </Paper>
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer}>
              {nextDayNavigationDisabled ?
                <Paper
                  className={classes.dateSelector + ' secondaryHeaderBackground headerText bgmediumgrey mediumgreen ' + classes.questionContainer + ' ' + classes.borderRightRounded}
                >
                  {
                    /*
                    <div className="bold" style={{ fontSize: '1.1em', }}>
                      {d3.timeFormat('%A')(nextDay)}
                    </div>  
                    */
                  }
                  <div>
                    {d3.timeFormat('%e %B')(nextDay)}
                  </div>
                  <IconButton className={classes.toolTipIconButton} data-for='day_after_tooltip' data-tip='day_after_tooltip'>
                    <HelpOutlineIcon />
                    {tooltipDayAfter}
                  </IconButton>
                </Paper>
                :
                <Paper
                  className={classes.dateSelector + ' secondaryHeaderBackground headerText bgmediumgrey mediumgreen ' + classes.hoverable + ' ' + classes.borderRightRounded}
                  onClick={() => props.changeCurrentDaySelected(d3.timeFormat('%Y%m%d')(nextDay))}
                >
                  {
                    /*
                    <div className="bold" style={{ fontSize: '1.1em', }}>
                      {d3.timeFormat('%A')(nextDay)}
                    </div>  
                    */
                  }

                  <div>
                    {d3.timeFormat('%e %B')(nextDay)}
                  </div>

                </Paper>
              }
            </Grid>
          </Grid>
        </Grid>
      )
    }
    else {
      // historical mode
      let previousYearNavigationDisabled = (previousYear < 2015);
      
      const tooltipYearBefore =
        <ReactTooltip id='year_before_tooltip' type='light' place='left' className={classes.toolTip}>
          {tooltipYearBeforeText}
        </ReactTooltip>
      const tooltipYearAfter =
        <ReactTooltip id='year_after_tooltip' type='light' place='right' className={classes.toolTip}>
          {availableFromJanuary}
        </ReactTooltip>

      return (
        <Grid item container xs={12}
          className={classes.container + ' darkbluegreen'}
          style={{
            minHeight: (boolHigherHeader ? '130px' : '110px'),
            maxHeight: (boolHigherHeader ? '130px' : '110px'),
          }}
        >
          <Grid item className={classes.heading}>
            {chooseA} <span
              className={classes.activeLink + " darkbluegreen"}
              onClick={() => props.displayCalendar(true, 'realtime')}
            >{day}</span> {or} <span
              className={classes.activeLink + " darkbluegreen"}
              //onClick={props.currentMode === "realtime"?props.changeMode:(()=>props.displayCalendar(true))}
              //onClick={props.changeMode}
              onClick={() => props.displayCalendar(true, 'historical')}
            >{year}</span>
          </Grid>
          <Grid item container xs={12} className={classes.selectorContainer}>
            <Grid item container xs={4} className={classes.dateContainer}>
              {previousYearNavigationDisabled ?
                <Paper
                  className={classes.questionContainer + ' bgmediumgrey headerText mediumgreen ' + classes.hoverable + ' ' + classes.borderLeftRounded}
                >
                  <IconButton className={classes.toolTipIconButton} data-for='year_before_tooltip' data-tip='year_before_tooltip'>
                    <HelpOutlineIcon />
                    {tooltipYearBefore}
                  </IconButton>
                </Paper>
                :
                <Paper
                  className={classes.dateSelector + ' bgmediumgrey headerText mediumgreen ' + classes.hoverable + ' ' + classes.borderLeftRounded}
                  data-year_selected={previousYear}
                  onClick={props.changeCurrentYearSelected}
                >
                  {previousYear}
                </Paper>
              }
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer}>
              <Paper
                className={classes.dateSelector + ' bggreenblue activeHeaderText'}
              >
                <div className="bold" style={{ fontSize: '1.1em', }}>
                  {props.selectedYear}
                </div>
              </Paper>
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer}>
              {nextYearNavigationDisabled ?
                <Paper
                  className={classes.questionContainer + ' bgmediumgrey mediumgreen headerText ' + classes.borderRightRounded}
                >
                  {nextYear} &nbsp;
                  <IconButton className={classes.toolTipIconButton} data-for='year_after_tooltip' data-tip='year_after_tooltip'>
                    <HelpOutlineIcon />
                    {tooltipYearAfter}
                  </IconButton>
                </Paper>
                :
                <Paper
                  className={classes.dateSelector + ' bgmediumgrey mediumgreen headerText ' + classes.hoverable + ' ' + classes.borderRightRounded}
                  data-year_selected={nextYear}
                  onClick={props.changeCurrentYearSelected}
                >
                  {nextYear}
                </Paper>
              }
            </Grid>
          </Grid>
        </Grid>
      )

    }
  }
  else {
    if (props.calendarMode === 'realtime') {
      let activeStartDate = new Date()
      let minDate = new Date()
      minDate.setMonth(minDate.getMonth() - 1)
      const maxDate = new Date(new Date().getTime() + 86400000)

      return (
        <Grid item container xs={12}>
          <Calendar
            activeStartDate={activeStartDate}
            value={props.selectedDate ? props.selectedDate : activeStartDate}
            className='calendar'
            tileClassName='calendar'
            //style={{ fontFamily: 'Nunito Sans Regular!important' }}
            locale={props.lang === 'de' ? 'de-DE' : (props.lang === 'en' ? 'en-GB' : 'fr-BE')}
            minDate={minDate}
            maxDate={maxDate}
            onClickDay={(value) => props.onDateChange(value)}
          />
        </Grid>
      )
    }
    else {
      //let minDate = new Date()
      //minDate.setMonth(minDate.getMonth() - 1)
      //const maxDate = new Date(new Date().getTime() + 86400000)

      //const minDate = new Date('2015-01-31')
      //const maxDate = new Date()
      //const selectedDate = new Date(props.selectedYear + '-01-31')
      const maxYear= new Date().getFullYear()-(props.currentYearNavigationDisabled?1:0)
      return (
        <Grid item container xs={12}>
        {
        /*  
          <Calendar
            activeStartDate={minDate}
            value={selectedDate}
            className='calendar'
            tileClassName='year'
            //style={{ fontFamily: 'Nunito Sans Regular!important' }}
            locale={props.lang === 'de' ? 'de-DE' : (props.lang === 'en' ? 'en-GB' : 'fr-BE')}
            minDate={minDate}
            maxDate={maxDate}
            onChange={(value) => props.onYearChange(value)}
            maxDetail="decade"
            view="decade"
          />
        */
        }  
          <YearCalendar
            minYear={2015}
            maxYear={maxYear}
            selectedYear={props.selectedYear}
            onChange={(value) => props.onYearChange(value)}
          >
          </YearCalendar>
        </Grid>
      )
    }
  }

}

DateSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DateSelector)